"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEmpty = exports.isDynamicNameAnnotation = exports.isBaseAnnotation = exports.findByTags = exports.filterAndOrderSlides = exports.equalIds = exports.buildSlidesMap = exports.buildSlideBuckets = void 0;
var _constants = require("../constants");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var equalIds = function equalIds(a, b) {
  if (a && a.equals) {
    return a.equals(b);
  }
  if (b && b.equals) {
    return b.equals(a);
  }
  return a === b;
};
exports.equalIds = equalIds;
var isEmpty = function isEmpty(value) {
  return value === null || value === undefined;
};
exports.isEmpty = isEmpty;
var isDynamicNameAnnotation = function isDynamicNameAnnotation(annotation) {
  return !!(annotation.subType && [_constants.AnnotationTypes.Highlight, _constants.AnnotationTypes.Strikethrough, _constants.AnnotationTypes.Focus, _constants.AnnotationTypes.Tooltip, _constants.AnnotationTypes.Correct, _constants.AnnotationTypes.Incorrect, _constants.AnnotationTypes.Delete, _constants.AnnotationTypes.Delete_v2, _constants.AnnotationTypes.Dynamic, _constants.AnnotationTypes.AnswerBase, _constants.AnnotationTypes.Choice].includes(annotation.subType));
};
exports.isDynamicNameAnnotation = isDynamicNameAnnotation;
var isBaseAnnotation = function isBaseAnnotation(annotation) {
  var rootId = annotation.rootId,
    startIndex = annotation.startIndex,
    endIndex = annotation.endIndex;
  return !!(!rootId || rootId && !rootId.startsWith('an-') && (startIndex || startIndex === 0) && endIndex);
};
exports.isBaseAnnotation = isBaseAnnotation;
var ImmediateBuffer = 3;
var buildSlideBuckets = function buildSlideBuckets(slides) {
  var slideBuckets = {
    primary: [],
    immediate: [],
    queued: [],
    conclusion: []
  };
  slides.forEach(function (s) {
    var adaptive = s.adaptive,
      type = s.type;
    if (type !== _constants.TemplateTypes.Conclusions) {
      switch (adaptive) {
        case _constants.AdaptiveTypes.immediate:
          slideBuckets.immediate.push(s);
          break;
        case _constants.AdaptiveTypes.queued:
          slideBuckets.queued.push(s);
          break;
        default:
          slideBuckets.primary.push(s);
          break;
      }
    } else {
      slideBuckets.conclusion.push(s);
    }
  });
  return slideBuckets;
};
exports.buildSlideBuckets = buildSlideBuckets;
var findByTags = function findByTags(tags, slides) {
  return slides.filter(function (is) {
    if (!is.tags || is.tags.length === 0) {
      return false;
    }
    var foundTags = is.tags.filter(function (t) {
      return tags.find(function (tag) {
        return tag.equals(t._id);
      });
    });
    return foundTags.length > 0;
  });
};
exports.findByTags = findByTags;
var filterAndOrderSlides = function filterAndOrderSlides(_ref) {
  var primary = _ref.primary,
    immediate = _ref.immediate,
    queued = _ref.queued,
    slideProgresses = _ref.slideProgresses;
  // Get all the Primary slides (slides that are adaptive === Primary
  // or slides that aren't adaptive) and order them
  var orderedSlides = _toConsumableArray(primary);
  orderedSlides.sort(function (a, b) {
    return (a.order || 0) - (b.order || 0);
  });

  // Iterate through the slides to determine if the learner has
  // completed and what the result was
  // If completed and incorrect, find corresponding Immediate
  // and Queued slides and splice Immediate to
  // index i + ImmediateBuffer into set and add Queued to end
  // Otherwise, move on to next slide
  var endLength = orderedSlides.length;
  var queuedSlides = [];
  var _loop = function _loop(i) {
    var s = orderedSlides[i];
    if (s.adaptive === _constants.AdaptiveTypes.primary) {
      var slideProgress = slideProgresses === null || slideProgresses === void 0 ? void 0 : slideProgresses.find(function (sp) {
        return sp.slideId.equals(s._id);
      });
      if (slideProgress) {
        var completed = slideProgress.completed,
          tries = slideProgress.tries,
          correct = slideProgress.correct;
        if (completed && (tries > 1 || !correct)) {
          var _s$tags;
          var tags = ((_s$tags = s.tags) === null || _s$tags === void 0 ? void 0 : _s$tags.map(function (t) {
            return t._id;
          })) || [];
          var immediateSlides = findByTags(tags, immediate);
          // eslint-disable-next-line @typescript-eslint/no-loop-func
          immediateSlides.forEach(function (is, ii) {
            orderedSlides.splice(i + ii + ImmediateBuffer, 0, is);
            endLength += 1;
          });
          queuedSlides.push.apply(queuedSlides, _toConsumableArray(findByTags(tags, queued)));
        }
      }
    }
  };
  for (var i = 0; i < endLength; i += 1) {
    _loop(i);
  }
  orderedSlides.push.apply(orderedSlides, queuedSlides);
  return orderedSlides;
};
exports.filterAndOrderSlides = filterAndOrderSlides;
var buildSlidesMap = function buildSlidesMap(_ref2) {
  var module = _ref2.module,
    slideProgresses = _ref2.slideProgresses,
    navItemId = _ref2.navItemId,
    ignoreNavItemId = _ref2.ignoreNavItemId;
  var slides = module.slides,
    useCustomNav = module.useCustomNav,
    customNav = module.customNav;
  if (useCustomNav && customNav) {
    if (!navItemId && !ignoreNavItemId) {
      return [];
    }
    var slideIds = [];
    var queue = _toConsumableArray((customNav === null || customNav === void 0 ? void 0 : customNav.navItems) || []);
    while (queue.length) {
      var navItem = queue.shift();
      if (navItem !== null && navItem !== void 0 && navItem._id) {
        if (navItem.children) {
          queue.unshift.apply(queue, _toConsumableArray(navItem.children));
        }
        if (navItem.slides) {
          if (ignoreNavItemId) {
            slideIds.push.apply(slideIds, _toConsumableArray(navItem.slides));
          } else if (navItemId && equalIds(navItemId, navItem._id)) {
            slideIds.push.apply(slideIds, _toConsumableArray(navItem.slides));
            break;
          }
        }
      }
    }
    var _slidesMap = [];
    slideIds.forEach(function (sId) {
      var slide = slides.find(function (s) {
        return s._id.equals(sId);
      });
      if (slide) {
        _slidesMap.push(_objectSpread(_objectSpread({}, slide), {}, {
          _slideId: slide._id
        }));
      }
    });
    return _slidesMap;
  }
  var slideBuckets = buildSlideBuckets(slides);
  var primary = slideBuckets.primary,
    immediate = slideBuckets.immediate,
    queued = slideBuckets.queued,
    conclusion = slideBuckets.conclusion;
  var filteredSlides = filterAndOrderSlides({
    primary: primary,
    immediate: immediate,
    queued: queued,
    slideProgresses: slideProgresses
  });
  var slidesMap = filteredSlides.map(function (s) {
    return _objectSpread(_objectSpread({}, s), {}, {
      _slideId: s._id
    });
  });
  slidesMap.push.apply(slidesMap, _toConsumableArray(conclusion.map(function (s) {
    return _objectSpread(_objectSpread({}, s), {}, {
      _slideId: s._id
    });
  })));
  return slidesMap;
};
exports.buildSlidesMap = buildSlidesMap;